import { render, staticRenderFns } from "./Tibet.vue?vue&type=template&id=996cfcb4&scoped=true"
import script from "./Tibet.vue?vue&type=script&lang=js"
export * from "./Tibet.vue?vue&type=script&lang=js"
import style0 from "./Tibet.vue?vue&type=style&index=0&id=996cfcb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996cfcb4",
  null
  
)

export default component.exports